module.exports = __webpack_public_path__ + "static/media/subituCV.472f93c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rrhh/subituCV.png
// module id = 1106
// module chunks = 0